import styled, { keyframes } from 'styled-components';
import star from '~/assets/icons/star_exp.svg';
import arrow from '../../assets/images/xp_arrow.svg';
import { TextLabelStroke } from '../TextLabelStroke';

const arrowKeyframes = keyframes`
	0% {
		opacity: 0;
		transform: translate(-50%, 100px);
	}
	100% {
		opacity: 1;
		transform: translate(-50%, -200px);
	}
`;

const StyledContainer = styled.div`
	position: relative;
`;

const StyledProgressBarContainer = styled.div`
	position: relative;

	circle {
		transition: all 0.3s ease;
	}
`;

const StyledCircle = styled.circle`
	rotate: 90deg;
	translate: 100% 0;
	transition: stroke-dashoffset 1s ease;
`;

const StyledLevelLabel = styled(TextLabelStroke)`
	position: absolute;
	top: 50%;
	right: 50%;
	transform: translate(50%, -55%);
	font-size: 16px;
	font-weight: 700;
	transition: all 0.3s ease;
`;

const StyledLevelUpArrow = styled.div`
	position: absolute;
	transform: translate(-50%, 100px);
	left: 50%;
	width: 82px;
	height: 100px;
	opacity: 0;
	mask-image: url(${arrow});
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-image: url(${arrow});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	background-color: #ffd600;
	mask-mode: luminance;
	animation-name: ${arrowKeyframes};
	animation-iteration-count: 1;
	animation-duration: 5s;
	animation-delay: 3s;
	animation-fill-mode: forwards;
`;

const StyledLevelUpLabel = styled.div`
	position: absolute;
	top: 50%;
	right: 50%;
	transform: translate(50%, -55%);
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 700;
	font-size: 16px;
	line-height: 18px;
	color: #000000;
	user-select: none;
	pointer-events: none;
`;

const StyledXPTextContainer = styled.div`
	position: absolute;
	display: flex;
	align-items: center;
	gap: 4px;

	${TextLabelStroke} {
		font-size: 14px;
		font-weight: 700;
	}

	transition:
		opacity 0.75s,
		top 0.75s;

	&.fade-enter {
		opacity: 0;
		top: 50px;
	}

	&.fade-enter-active,
	&.fade-enter-done,
	&.fade-exit {
		opacity: 1;
		top: 66px;
	}

	&.fade-exit-active {
		opacity: 0;
		top: 50px;
	}
`;

const StyledStar = styled.div`
	width: 10px;
	height: 10px;
	mask-image: url(${star});
	mask-position: center;
	mask-repeat: no-repeat;
	mask-size: 10px 10px;
	-webkit-mask-image: url(${star});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-size: 10px 10px;
	background-color: #ffb500;
	box-shadow:
		1px 0 0 rgba(0, 0, 0, 0.4),
		0 1px 0 rgba(0, 0, 0, 0.4),
		-1px 0 0 rgba(0, 0, 0, 0.4),
		0 -1px 0 rgba(0, 0, 0, 0.4);
`;

const StyledStarBorder = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 14px;
	height: 14px;
	mask-image: url(${star});
	mask-position: center;
	mask-repeat: no-repeat;
	mask-size: 14px 14px;
	-webkit-mask-image: url(${star});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-size: 14px 14px;
	background-color: rgba(0, 0, 0, 0.4);
`;

export {
	StyledContainer,
	StyledProgressBarContainer,
	StyledCircle,
	StyledLevelLabel,
	StyledXPTextContainer,
	StyledStar,
	StyledStarBorder,
	StyledLevelUpLabel,
	StyledLevelUpArrow,
};
